<template>
    <section id="dailyDateNavigation">
        <div class="d-flex align-items-center justify-content-start date-toggle-container">
            <i :class="'fas fa-chevron-left cursor-pointer'" @click="decrementTaskDate()"></i>
            <span class="mx-2 font-size-sm fw-bold">
                {{ formatDate(startDate.toString(), "ddd, DD MMM , YYYY") }}
            </span>
            <span class="calendar-icon d-flex justify-content-center align-items-center" @click="toggleCalendar">
                <i :class="`fas fa-calendar-alt ${showCalendar == true ? 'active' : ''}`"></i>
            </span>
            <i :class="'fas fa-chevron-right cursor-pointer ps-1'" @click="incrementTaskDate()"></i>
        </div>
        <div class="calendar-no-visits-vue text-dark mt-2" v-show="showCalendar">
            <div ref="noVisitDatePicker" class="schedule-calendar"></div>
        </div>
    </section>
</template>

<style src="./DailyDateNavigation.scss"></style>
<script lang="ts" src="./DailyDateNavigation.ts"></script>
